export default __webpack_public_path__ + "static/fintracase2-f33d7e39608927c2cfc0c04c916d614f.png";